import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Fade,
  Backdrop,
  IconButton,
  Container
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PrivacyPolicyModal = (props) => {
  const { open, onClose } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            maxHeight: '90vh',
            overflowY: 'auto',
            width: { xs: '90%', sm: '80%', md: '60%' },
            p: 3,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Informativa sulla Privacy</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Container>
            <Typography variant="body1" paragraph>
              Questo sito utilizza esclusivamente <strong>cookie tecnici e funzionali</strong>, necessari per garantire il corretto funzionamento delle pagine e una navigazione fluida.
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
              🔍 Cosa sono i cookie?
            </Typography>
            <Typography variant="body2" paragraph>
              I cookie sono piccoli file di testo che i siti web inviano al dispositivo dell’utente durante la navigazione. Servono a memorizzare informazioni utili per migliorare l’esperienza dell’utente.
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
              ✅ Tipologie di cookie utilizzate
            </Typography>
            <Typography variant="body2" paragraph>
              <ul>
                <li><strong>Cookie tecnici</strong>: indispensabili per il funzionamento del sito.</li>
                <li><strong>Cookie funzionali</strong>: migliorano la navigazione, ad esempio ricordando le preferenze dell’utente.</li>
              </ul>
              ❌ Questo sito <strong>non utilizza</strong> cookie di profilazione, marketing o tracciamento di terze parti.
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
              📌 Consenso
            </Typography>
            <Typography variant="body2" paragraph>
              Poiché i cookie utilizzati sono <strong>strettamente necessari</strong> alla navigazione, <strong>non è richiesto il consenso preventivo</strong> dell’utente.
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
              🔒 Gestione dei cookie
            </Typography>
            <Typography variant="body2" paragraph>
              L’utente può gestire o disabilitare i cookie dalle impostazioni del proprio browser. La disattivazione dei cookie tecnici potrebbe compromettere il funzionamento del sito.
            </Typography>
          </Container>
        </Box>
      </Fade>
    </Modal>
  );
};

export default PrivacyPolicyModal;
